import { defineComponent as _defineComponent } from 'vue'
import Dialog from "primevue/dialog";
import InvestmentCalculator from "@/components/buyTokens/InvestmentCalculator.vue";
import {TokenReservation} from "@/store/publicSales.store";
import {computed} from "vue";
import {useUserServiceStore} from "@/store/userService.store";
import {useConfigurationStore} from "@/store/configuration.store";
import {AddressType} from "@/components/buyTokens/modals/AddressType";


export default /*#__PURE__*/_defineComponent({
  __name: 'WarningModal',
  props: {
  visible: {
    type: Boolean,
    required: true
  }
},
  emits: ["closeModal", 'confirm'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit;
const sourceAddress = computed(() => {
  return useUserServiceStore().ethereumAddress;
});

const __returned__ = { emit, sourceAddress, get Dialog() { return Dialog } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})